import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import MessageView from "../../FO/components/message/MessageView";
import { MessageTypeDemande, MessageTypeView, Type_Reponse_Message } from "../../../config/helpers";
import { IFormMessageReponse } from "../../../components/IFormMessage";
import { useLazyFetchBOmessageQuery, useUpdatereponsemessageMutation } from "../../../redux/slice/api/BO/messageApi";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import { toast } from "react-toastify";
import { IMessage } from "../../../models/interfaces/IMessage";
import MarqueDetails from "../../FO/MarqueDetails/MarqueDetails";
import MarqueDetailsPreview from "../../FO/MarqueDetails/MarqueDetailsPreview";
import { useFetchSocieteQuery } from "../../../redux/slice/api/FO/societeApi";
import SpinnerEditeurPro from "../../FO/components/SpinnerEditeurPro";
import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
 
const PageBOMarqueDetailsMessageReponse: React.FC = () => {
  const [Actif, setActif] = useState(false);
  const [IdMessage, setIdMessage] = useState<number|null>(null);
  const [message, setMessage] = useState<IMessage|null>(null);
 
  const detail = () => {
    setActif(!Actif);
  }

  const navigate = useNavigate();
  const { idmarque:idmarqueUrl, idmessage:idmessageUrl } = useParams();
  const idmarqueValue = idmarqueUrl ?? "";
 
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  const [triggerGetMessage, { data: MessageResult, isFetching: isFetchingMessage, error: Messageerror }] = useLazyFetchBOmessageQuery();

  const { data: MarqueResult, isFetching } = useFetchSocieteQuery(idmarqueValue, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || idmarqueValue === null || idmarqueValue === "",
    });

  useEffect(() => {
    if (MessageResult ) {
      if (MessageResult?.Message?.Id && MessageResult?.Message?.Id > 0) {
        setMessage(MessageResult?.Message);
      } else {
        navigate(`/admin/demandes`);
      }
      
    } 
    
  }, [MessageResult])


  useEffect(() => {
    !isNaN(Number(idmessageUrl)) && setIdMessage(Number(idmessageUrl));
  }, [idmessageUrl]);


  useEffect(() => {
    if (keycloakinitialized && keycloak.authenticated && IdMessage) {
      triggerGetMessage(IdMessage);
    }
  }, [keycloakinitialized, keycloak.authenticated, IdMessage, triggerGetMessage]);


  const [
    updateReponseMessage,
    {
    //isSuccess: isSuccessUpdateReponsemessage,
    error: errorUpdateReponsemessage,
    reset: resetUpdateReponsemessage
  }] = useUpdatereponsemessageMutation();

  const [
    updateReponseMessageBloque,
    {
    //isSuccess: isSuccessupdateReponseMessageBloque,
    error: errorupdateReponseMessageBloque,
    reset: resetupdateReponseMessageBloque
  }] = useUpdatereponsemessageMutation();

  


  const handleBloquerReponse = async (bloquer:boolean) => {


    //if (MessageResult !== undefined && MessageResult?.Id !== undefined && MessageResult.Id > 0) {
      if (message && message?.Id !== undefined && message.Id > 0) {
     //UPDATE
     const response = await updateReponseMessageBloque(
       {
         //...data,
         Id:message && message.Id ? message.Id : -1,
         MessageReponse: "",
         IdTypeReponse: bloquer ? Type_Reponse_Message.TraitementEnCours : Type_Reponse_Message.Nouveau 
       }
     ).unwrap();

     if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
       resetupdateReponseMessageBloque();
       response.Return_Message && 
       toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
     } else if (!isNaN(Number(response?.Message.Id))) {
        setMessage(response?.Message);
        resetupdateReponseMessageBloque();
        toast.success(<div dangerouslySetInnerHTML={{ __html: response?.Message?.IdTypeReponse === Type_Reponse_Message.Nouveau ? "La réponse ne vous est plus attribuée" : "La réponse vous est attribuée" }} />,);
     }

     }
 }



 const handleUpdateReponse = async (data:IFormMessageReponse) => {
      if (message && message?.Id !== undefined && message.Id > 0) {
    //UPDATE
    const response = await updateReponseMessage(
      {
        //...data,
        Id:message && message.Id ? message.Id : -1,
        MessageReponse: data.MessageReponse,
        IdTypeReponse: data.IdTypeReponse,
        TitreNoticeOrMarque: MarqueResult?.Societe?.RaisonSociale
      }
    ).unwrap();

    if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      resetUpdateReponsemessage();
      response.Return_Message &&
      toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
    } else if (!isNaN(Number(response?.Message.Id))) {
      setMessage(response?.Message);
      resetUpdateReponsemessage();
      toast.success(<div dangerouslySetInnerHTML={{ __html: "La réponse a été enregistrée et communiquée au client." }} />,);
    }

    }
  }

  if (errorUpdateReponsemessage || errorupdateReponseMessageBloque) { 
      //
  } 

  if (Messageerror) {
    return (
      <div>Error</div>
    );
  } 

  if (isFetchingMessage) {
    return (
    <SpinnerEditeurPro />
    )
  }
  
  return (
    <>
      <div className="container">
        <div className="row">
                  <div className="col-9 mt-2 d-flex justify-content-start">
                  {/* {<>Votre contact :&nbsp;<b>{MarqueResult?.SuiviPar ? MarqueResult?.SuiviPar : 'biblio@electre.com'}</b></>}  */}
                  {<>Contact Electre :&nbsp;<b>{message?.SuiviPar ? message?.SuiviPar : 'biblio@electre.com'}</b></>} 
                  </div>
            </div>
          {
           MarqueResult && MarqueResult?.Return_IdType_Message === Type_Return_Message.Erreur ?
           <div>
             <CpntDetailsNotAccess text="Aucune marque Electre trouvée." typeAffichage={TypeAffichage.Societe} />
           </div>
           :
          !Actif ? 
            <>
                <div className="row">
                    <div className="col-12 mt-2">
                      <MarqueDetailsPreview MarqueResult={MarqueResult} isFetchingMarqueResult={isFetching} ></MarqueDetailsPreview>
                    </div>
                </div>
                <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                  <div className="row">
                      <i className="col-12 bi-caret-down-fill"></i>
                  </div>
                </div>
            </> 
            :  
            <>
            {/* navigatorPath={"../marquedetailsmessage/"} */}
              <MarqueDetails MarqueResult={MarqueResult} isFetchingMarqueResult={isFetching} btnModifierVisible={false} ></MarqueDetails>
              <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                <div className="row">
                    <i className="col-12 bi bi-caret-up"></i>
                </div>
              </div>
            </>
          }
        </div>
        {
      <div className="row mt-2" style={{ textAlign: 'left' }}>
        <MessageView Message={message ? message : undefined} typeView={MessageTypeView.Demande} typeDemande={MessageTypeDemande.Societe} />
        <MessageView bloquerReponse={handleBloquerReponse} enregistrerReponse={handleUpdateReponse} Message={message ? message : undefined} typeView={MessageTypeView.Reponse} typeDemande={MessageTypeDemande.Societe} />
      </div>
    } 
    </>
    
  );

};
 
export default PageBOMarqueDetailsMessageReponse;
 